// Rejection Reasons Service
// Manages predefined rejection reasons for applications and job requests

import { db } from '../config/firebase';
import { ref, get, set } from 'firebase/database';

// Predefined rejection reasons
const REJECTION_REASONS = {
  APPLICATION: [
    'Insufficient qualifications for this position',
    'Experience does not match job requirements',
    'Failed to meet educational requirements',
    'Communication skills do not meet standards',
    'Availability does not match position needs',
    'Background check did not clear',
    'Position already filled',
    'Better qualified candidates available',
    'Salary expectations do not align',
    'Other'
  ],
  JOB_REQUEST: [
    'The job is too demanding for the time given',
    'The pay for the job is too low for the labor',
    'Insufficient workers available for this request',
    'Location is not covered by our service area',
    'Request does not meet minimum budget requirements',
    'Timeline is too tight for quality work',
    'Skill level not available',
    'Request lacks sufficient detail',
    'Duplicate request already processed',
    'Other'
  ]
};

// Initialize rejection reasons in Firebase (runs once)
export const initializeRejectionReasons = async () => {
  try {
    const reasonsRef = ref(db, 'system/rejectionReasons');
    const snapshot = await get(reasonsRef);

    if (!snapshot.exists()) {
      await set(reasonsRef, REJECTION_REASONS);
      console.log('✅ Rejection reasons initialized');
    }
  } catch (error) {
    console.error('Error initializing rejection reasons:', error);
  }
};

// Get rejection reasons
export const getRejectionReasons = async (type) => {
  try {
    // First try to get from Firebase
    const reasonsRef = ref(db, `system/rejectionReasons/${type}`);
    const snapshot = await get(reasonsRef);

    if (snapshot.exists()) {
      return snapshot.val();
    }
  } catch (error) {
    console.error('Error fetching rejection reasons from Firebase:', error);
  }

  // Fallback to local ones
  return REJECTION_REASONS[type] || [];
};

// Get all rejection reasons
export const getAllRejectionReasons = () => {
  return REJECTION_REASONS;
};

// Add custom rejection reason
export const addCustomRejectionReason = async (type, reason) => {
  try {
    const reasonsRef = ref(db, `system/rejectionReasons/${type}`);
    const snapshot = await get(reasonsRef);

    const currentReasons = snapshot.exists() ? snapshot.val() : [];

    // Avoid duplicates
    if (!currentReasons.includes(reason)) {
      currentReasons.push(reason);
      await set(reasonsRef, currentReasons);
      console.log('✅ Custom rejection reason added');
    }
  } catch (error) {
    console.error('Error adding custom rejection reason:', error);
    throw error;
  }
};

// Export for admin side
export const getApplicationRejectionReasons = () => REJECTION_REASONS.APPLICATION;
export const getJobRequestRejectionReasons = () => REJECTION_REASONS.JOB_REQUEST;
